<form class="field-dialog__content__scroll p-24 form-component" fxLayout="column" name="form" fusePerfectScrollbar>
  <mat-form-field appearance="outline">
    <mat-label>{{ 'MAINTENANCES.TABS.FORMS.FILTER.TITLE' | translate }}</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input type="text" matInput (input)="filterForms($event.target.value)" data-cy="input-filter-forms" />
    <mat-hint>{{ 'MAINTENANCES.TABS.FORMS.FILTER.HINT' | translate }}</mat-hint>
  </mat-form-field>

  <span class="form-component__title">
    {{ 'MAINTENANCES.TABS.FORMS.TOTAL_FORMS' | translate: { totalForms: forms.length } }}
  </span>

  <div class="card form-component__card" *ngFor="let form of forms" fxLayout="row">
    <i class="angularjs-fuse-icon icon-clipboard-text form-component__card__icon" *ngIf="!form.equipment"></i>
    <img
      class="angularjs-fuse-icon icon-build form-component__card__icon"
      src="assets/images/icons/build.svg"
      *ngIf="form.equipment"
    />

    <div class="form-component__card__info">
      <div class="form-component__card__info__title">
        {{ form.name }}
        <span class="form-component__card__info__title__archived" *ngIf="form.archived">
          ({{ 'MAINTENANCES.TABS.FORMS.FORM_DETAILS.ARCHIVED' | translate }})
        </span>

        <span class="form-component__card__info__title__equipment" *ngIf="form.equipment">
          - {{ form.equipment.number }} - {{ form.equipment.name }}
        </span>

        <span class="form-component__card__info__title__tag" *ngIf="form.tag"> - {{ form.tag }} </span>
      </div>

      <div class="form-component__card__info__subtitle">
        {{
          'MAINTENANCES.TABS.FORMS.CARD.CREATED_AT'
            | translate: { createdAt: form.createdAt | date: 'dd/MM/yyyy HH:mm' }
        }}
        <span class="form-component__card__info__subtitle__equipment" *ngIf="form.equipment">
          {{ 'MAINTENANCES.TABS.FORMS.CARD.EQUIPMENT_TYPE' | translate }} {{ form.equipment.type.name }}
        </span>
      </div>
    </div>

    <i
      class="angularjs-fuse-icon icon-eye form-component__card__more-info"
      (click)="openForm(form.questionAnswers, form.name)"
      data-cy="form-details"
    >
    </i>
  </div>
</form>
